import { StyledIconButton } from './style';

const IconButton = ({ icon, text, btnTheme, disabled, ...restProps }) => (
  <StyledIconButton startIcon={icon} btnTheme={btnTheme} disabled={disabled} disableRipple {...restProps}>
    {text}
  </StyledIconButton>
);

export default IconButton;
